// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.url-editor .image-container {
  position: relative;
  display: inline-block;
}
.url-editor .image-container img {
  border: 1px solid rgba(128, 128, 128, 0.5);
  max-width: 100%;
  max-height: 256px;
}
.url-editor .image-dimensions {
  display: block;
  text-align: center;
  font-size: 12px;
  opacity: 0.6;
  margin: 8px;
}
.url-editor .image-filename {
  display: block;
  text-align: center;
  font-size: 12px;
  opacity: 0.6;
  margin: -4px 8px 8px 8px;
}
.url-editor .delete {
  position: absolute;
  top: -4px;
  right: -4px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  color: white;
  width: 18px;
  border-radius: 50%;
  font-size: 10px;
}
.url-editor .edit {
  position: absolute;
  bottom: 48px;
  right: -8px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1890ff;
  color: white;
  width: 36px;
  border-radius: 50%;
  font-size: 18px;
}
.nkl-image-preview-operations {
  background: rgba(0, 0, 0, 0.8);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
